import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { DashboardLayout } from './components/dashboard/DashboardLayout'
import { ErrorBoundary } from './components/common/ErrorBoundary'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { UsersPage } from './pages/UsersPage'
import { ActivitiesPage } from './pages/ActivitiesPage'
import { AnalyticsPage } from './pages/AnalyticsPage'
import { FinancialPage } from './pages/FinancialPage';
import { InvitationsPage } from './pages/InvitationsPage';
import { AdminMembersPage } from './pages/AdminMembersPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { TripsPage } from './pages/TripsPage';
import { PhotosPage } from './pages/PhotosPage';
import { SettingsPage } from './pages/SettingsPage';
import { InfluencerPage } from './pages/InfluencerPage';
import { InfluencerMembersPage } from './pages/InfluencerMembersPage';
import { MapViewPage } from './pages/MapViewPage';

function AppContent() {
   const { user, loading } = useAuth();

  if (loading) {
     return (
        <div className='min-h-screen flex items-center justify-center'>
           <div className='animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600'></div>
        </div>
     );
  }

  return (
     <Routes>
        <Route path='/login' element={user ? <Navigate to='/' replace /> : <LoginPage />} />
        <Route
           path='/change-password'
           element={user ? <ChangePasswordPage /> : <Navigate to='/login' replace />}
        />
        <Route
           path='/'
           element={
              <ProtectedRoute>
                 <DashboardLayout />
              </ProtectedRoute>
           }
        >
           <Route index element={<DashboardPage />} />
           <Route path='users' element={<UsersPage />} />
           <Route path='activities' element={<ActivitiesPage />} />
           <Route path='analytics' element={<AnalyticsPage />} />
           <Route path='financial' element={<FinancialPage />} />
           <Route path='invitations' element={<InvitationsPage />} />
           <Route path='admin-members' element={<AdminMembersPage />} />
           <Route path='trips' element={<TripsPage />} />
           <Route path='photos' element={<PhotosPage />} />
           <Route path='map' element={<MapViewPage />} />
           <Route path='settings' element={<SettingsPage />} />
           <Route path='influencer' element={<InfluencerPage />} />
           <Route path='influencer-members' element={<InfluencerMembersPage />} />
        </Route>
        <Route path='*' element={<Navigate to='/' replace />} />
     </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AppContent />
    </ErrorBoundary>
  )
}

export default App 